/* MXDVS homepage hero, stage 1 (04.10.2026). Homepage only, loaded with defer from sections/mxdvs-hero-video.liquid.
   1. Scroll down: still ruler, the light steps down one tick at a time, every tick fades out on its own
   2. The needle at the bottom of the ruler follows the flickering 0 (set by assets/mxdvs-header.js part 6)
   3. Tube switch-off of the scroll down alone (only when the TV effect of assets/mxdvs-hero-fallout.js is not installed)
   4. Clicking SCR0LL slides the page down 100% of the hero height; the ruler and the text stand still while it slides
   05.10.2026: the glitch and TV effect only play during this click slide. The slide asks assets/mxdvs-hero-fallout.js
   to pin the hero (window.MxHeroFx.begin) and lets it take the pin away again at the end (window.MxHeroFx.finish).
   While the effect plays, scrolling by hand is held for its 1 to 2 seconds so the effect always ends cleanly.
   Scrolling by hand at any other moment just scrolls the page.
   The temporary test switch (&mxtest=) of 05.10.2026 is removed.
   The sideways SCR0LL text itself is not changed. Nothing here edits assets/mxdvs-header.js. */
(function () {
  'use strict';
  if (window.__mxHeroHome) return;
  window.__mxHeroHome = true;

  /* @settings */
  var CFG = {
    GLOW_MS: 2400,         // one run from the top to the bottom of the ruler
    GLOW_BLUR: 2,          // px of glow around a lit tick
    GLOW_BAND: 17.5,       // px length of the fading trail
    GLOW_MAX: 1,           // brightness of a lit tick, 0 to 1
    TICK: 3.5,             // px between two ticks
    PIN: 0.7,              // switch-off range of the ruler alone (only used when the TV effect is not installed)
    SLIDE_MS_PER_1000: 1800, // slide after a click on SCR0LL: ms for every 1000px
    SLIDE_MIN_MS: 1400,    // never faster than this
    SLIDE_MAX_MS: 3200,    // never slower than this
    SLIDE_GLITCH_SPEED: 4, // the glitch part of the slide (before the TV switch-off) plays this many times faster.
                           // 1 = as before. The TV switch-off and everything after it keep exactly their time.
    SLIDE_GLITCH_SPEED_PHONE: 2 // the same on screens below 990px
  };
  /* @end */

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    var hero = document.querySelector('.header-wrapper .header');
    var btn = document.querySelector('.header-wrapper .scroll-down-button');
    var line = btn && btn.querySelector('.animated-blurry-line');
    if (!hero || !btn || !line) return;

    var desc = hero.querySelector('.featured-collection-banner-description');
    var links = hero.querySelector('.featured-collection-banner-links');
    var zero = btn.querySelector('.scroll-text .neon-flicker');

    /* ---------- the ruler: a faded layer (spine and ticks) and the needle outside the fade ---------- */
    line.innerHTML = '<span class="mx-rl"></span><b class="mx-needle"></b>';
    var rl = line.querySelector('.mx-rl');
    btn.classList.add('mx-ruler-on');
    rl.style.setProperty('--mx-peak', CFG.GLOW_MAX);
    rl.style.setProperty('--mx-blur', CFG.GLOW_BLUR + 'px');

    var ticks = [];
    var k = 0;
    var stepMs = 100;
    var trail = Math.max(1, Math.round(CFG.GLOW_BAND / CFG.TICK));
    var lastH = 0;
    var timer = 0;
    var running = false;
    var heroVisible = true;

    /* As tall as the description and the buttons, level with the buttons.
       Uses layout sizes (offsetTop), so a squashed hero during the TV effect never changes it. */
    function measure() {
      var h = 90;
      if (desc && links && desc.offsetParent && desc.offsetParent === links.offsetParent) {
        var m = links.offsetTop + links.offsetHeight - desc.offsetTop;
        if (m > 0) h = Math.max(35, Math.round(m));
      }
      btn.style.setProperty('--mx-track', h + 'px');
      build(h);
    }

    function build(h) {
      if (!h || h === lastH) return;
      lastH = h;
      var dpr = window.devicePixelRatio || 1;
      var n = Math.floor((h - 1) / CFG.TICK) + 1;
      var html = '';
      for (var i = 0; i < n; i++) {
        html += '<i' + (i % 5 === 0 ? ' class="lg"' : '') + ' style="top:' + (Math.round(i * CFG.TICK * dpr) / dpr) + 'px"></i>';
      }
      rl.innerHTML = html;
      ticks = Array.prototype.slice.call(rl.querySelectorAll('i'));
      stepMs = CFG.GLOW_MS / (ticks.length + trail);
      rl.style.setProperty('--mx-fade', Math.round(stepMs * trail) + 'ms');
      k = 0;
    }

    /* ---------- tick by tick glow ---------- */
    function step() {
      if (!running) return;
      if (ticks.length) {
        var t = ticks[k % (ticks.length + trail)];
        if (t) {
          t.classList.add('lit');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { t.classList.remove('lit'); });
          });
        }
        k++;
      }
      timer = setTimeout(step, stepMs);
    }
    function start() {
      if (running || reduce.matches || !heroVisible || document.hidden || !ticks.length) return;
      running = true;
      step();
    }
    function stop() {
      running = false;
      clearTimeout(timer);
    }

    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(measure);
      ro.observe(hero);
      if (desc) ro.observe(desc);
      if (links) ro.observe(links);
    }

    /* Only runs while the hero is on screen and the tab is visible */
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        heroVisible = entries[0].isIntersecting;
        if (heroVisible) start(); else stop();
      }).observe(hero);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });
    start();

    /* ---------- the needle follows the morse 0 ---------- */
    if (zero) {
      var syncNeedle = function () {
        if (sliding) return;
        btn.classList.toggle('is-morse-on', parseFloat(zero.style.opacity) > 0.5);
      };
      new MutationObserver(syncNeedle).observe(zero, { attributes: true, attributeFilter: ['style'] });
      syncNeedle();
    }

    /* ---------- tube switch-off while scrolling (only without the TV effect) ---------- */
    var ticking = false;
    var lastKey = '';
    var sliding = false;
    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
    function tube() {
      ticking = false;
      if (document.documentElement.classList.contains('mx-fx-on')) {
        if (btn.style.transform) { btn.style.transform = ''; btn.style.filter = ''; btn.style.pointerEvents = ''; }
        return;
      }
      if (reduce.matches || sliding) return;
      var range = Math.max(1, hero.offsetHeight * CFG.PIN);
      var p = clamp(window.scrollY / range, 0, 1);
      var sx = clamp((0.4 - p) / 0.1, 0, 1);
      var sy = Math.max(0.03, 1 - p * 3.4);
      var br = 1 + p * 3;
      var key = sx.toFixed(3) + '|' + sy.toFixed(3);
      if (key === lastKey) return;
      lastKey = key;
      /* At the top of the page nothing is set, so the scroll down is drawn exactly as before */
      if (p === 0) {
        btn.style.transform = '';
        btn.style.filter = '';
      } else {
        btn.style.transform = 'scale(' + sx.toFixed(3) + ',' + sy.toFixed(3) + ')';
        btn.style.filter = 'brightness(' + br.toFixed(2) + ')';
      }
      btn.style.pointerEvents = p > 0.3 ? 'none' : '';
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(tube); }
    }, { passive: true });
    tube();

    /* ---------- SCR0LL slides the page down 100% of the hero height ----------
       Runs in the capture phase on the document, so the older smooth scroll in assets/mxdvs-header.js (part 5) never fires. */
    var slideId = 0;
    var fxRun = false;
    /* While sliding, the ruler and the text do not animate: no tube shrink, no glow, a steady 0 */
    function setSliding(on) {
      if (sliding === on) return;
      sliding = on;
      btn.classList.toggle('is-sliding', on);
      if (on) {
        stop();
        btn.style.transform = '';
        btn.style.filter = '';
        btn.style.pointerEvents = '';
      } else {
        lastKey = '';
        start();
        tube();
      }
    }
    /* Scrolling by hand stops a plain slide. While the effect plays it is held instead (1 to 2 seconds),
       so the hero never stays half pinned. */
    function cancelSlide() {
      if (fxRun) return;
      slideId++;
      setSliding(false);
    }
    var SCROLL_KEYS = { ' ': 1, PageDown: 1, PageUp: 1, ArrowDown: 1, ArrowUp: 1, Home: 1, End: 1, Spacebar: 1 };
    function hold(event) {
      if (!fxRun) return;
      if (event.type === 'keydown' && !SCROLL_KEYS[event.key]) return;
      if (event.cancelable) event.preventDefault();
    }
    ['wheel', 'touchmove', 'keydown'].forEach(function (name) {
      window.addEventListener(name, hold, { passive: false });
    });
    /* Position on the slide (0 to 1) for a time (0 to 1): ease in and out, and the other way round */
    function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function easeBack(e) { return e < 0.5 ? Math.cbrt(e / 4) : 1 - Math.cbrt(2 * (1 - e)) / 2; }

    function slide() {
      if (fxRun) return;
      var block = hero.closest('.header-wrapper') || hero;
      var from = window.scrollY;
      if (reduce.matches) {
        window.scrollTo({ top: Math.round(block.getBoundingClientRect().bottom + from), behavior: 'instant' });
        return;
      }
      /* The effect gets its scroll room first, so the slide runs through it */
      var fx = window.MxHeroFx;
      fxRun = !!(fx && fx.begin && fx.begin());
      var to = Math.round(block.getBoundingClientRect().bottom + from);
      var id = ++slideId;
      function done() {
        if (fxRun) { fxRun = false; fx.finish(); }
        setSliding(false);
      }
      if (Math.abs(to - from) < 2) {
        window.scrollTo({ top: to, behavior: 'instant' });
        done();
        return;
      }
      setSliding(true);
      var dur = clamp(Math.abs(to - from) * CFG.SLIDE_MS_PER_1000 / 1000, CFG.SLIDE_MIN_MS, CFG.SLIDE_MAX_MS);

      /* The glitch part of the slide (everything before the TV switch-off starts) can play faster.
         assets/mxdvs-hero-fallout.js writes where the switch-off starts (px from the top of the page) on the hero block.
         The time before that point is shortened, the time after it stays exactly as it was. */
      var phone = window.matchMedia('(max-width: 989px)').matches;
      var k = 1 / clamp(phone ? CFG.SLIDE_GLITCH_SPEED_PHONE : CFG.SLIDE_GLITCH_SPEED, 1, 6);
      var tvY = parseFloat(block.getAttribute('data-mx-tv-start'));
      var oldGlitch = 0;                                   /* ms the glitch part took before */
      if (fxRun && k < 1 && !isNaN(tvY) && tvY > from && tvY < to) oldGlitch = easeBack((tvY - from) / (to - from)) * dur;
      var newGlitch = oldGlitch * k;
      var total = dur - (oldGlitch - newGlitch);

      var t0 = performance.now();
      (function frame(now) {
        if (id !== slideId) return;
        var elapsed = now - t0;
        var old = elapsed < newGlitch ? elapsed / k : elapsed + (oldGlitch - newGlitch);
        var e = ease(clamp(old / dur, 0, 1));
        window.scrollTo({ top: from + (to - from) * e, behavior: 'instant' });
        if (elapsed < total) requestAnimationFrame(frame);
        else {
          window.scrollTo({ top: to, behavior: 'instant' });
          done();
        }
      })(t0);
    }
    document.addEventListener('click', function (event) {
      var hit = event.target && event.target.closest && event.target.closest('.header-wrapper .scroll-down-button');
      if (!hit) return;
      event.preventDefault();
      event.stopPropagation();
      slide();
    }, true);
    ['wheel', 'touchstart', 'keydown'].forEach(function (name) {
      window.addEventListener(name, cancelSlide, { passive: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
